import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0b64d585"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content title"
};
const _hoisted_2 = {
  class: "match-meta"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  key: 2
};
const _hoisted_6 = {
  class: "threshold-bar"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "threshold-label"
}, "置信度", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section-title"
}, "三次分析", -1));
const _hoisted_9 = {
  class: "stage-timeline"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "stage-info"
};
const _hoisted_12 = {
  class: "stage-name"
};
const _hoisted_13 = {
  class: "stage-time"
};
const _hoisted_14 = {
  class: "rec-card"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section-title"
}, "总置信度", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section-title"
}, "亚盘推荐", -1));
const _hoisted_17 = {
  class: "rec-main"
};
const _hoisted_18 = {
  class: "rec-meta"
};
const _hoisted_19 = {
  key: 0,
  class: "rec-reason"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section-title"
}, "大小球推荐", -1));
const _hoisted_21 = {
  class: "rec-main"
};
const _hoisted_22 = {
  class: "rec-meta"
};
const _hoisted_23 = {
  key: 0,
  class: "rec-reason"
};
const _hoisted_24 = {
  class: "rec-card"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section-title"
}, "推荐比分", -1));
const _hoisted_26 = {
  class: "score-grid"
};
const _hoisted_27 = {
  class: "score-num"
};
const _hoisted_28 = {
  key: 0,
  class: "score-reason"
};
const _hoisted_29 = {
  key: 0,
  class: "rec-card"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section-title"
}, "分析摘要", -1));
const _hoisted_31 = {
  class: "rec-text"
};
const _hoisted_32 = {
  key: 1,
  class: "rec-card"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "关键推理要点", -1));
const _hoisted_34 = {
  class: "toggle-arrow"
};
const _hoisted_35 = {
  key: 0,
  class: "reason-points"
};
const _hoisted_36 = {
  key: 2,
  class: "rec-card"
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section-title"
}, "风险提示", -1));
const _hoisted_38 = {
  class: "rec-risk"
};
const _hoisted_39 = {
  key: 1,
  class: "no-data"
};
const _hoisted_40 = {
  key: 2,
  class: "no-data"
};
import { ref, computed, watch } from 'vue';
import axios from 'axios';
export default {
  __name: 'AiPredictionView',
  setup(__props, {
    expose: __expose
  }) {
    const isVisible = ref(false);
    const loading = ref(false);
    const matchId = ref('');
    const homeTeam = ref('');
    const awayTeam = ref('');
    const league = ref('');
    const matchNumStr = ref('');
    const matchTime = ref('');
    const deadline = ref('');
    const stageTimes = ref([]);
    const stages = ref([]);
    const currentStage = ref(0);
    const showReason = ref(false);

    // 置信度阈值（0=全部），持久化
    const threshold = ref(Number(localStorage.getItem('aiPredThreshold') || 0));
    watch(threshold, val => {
      localStorage.setItem('aiPredThreshold', String(val));
    });
    const stageMeta = computed(() => [{
      stage: 1,
      label: '第一次分析',
      time: stageTimes.value[0] || '待定'
    }, {
      stage: 2,
      label: '赛前2小时',
      time: stageTimes.value[1] || '待定'
    }, {
      stage: 3,
      label: '赛前30分钟',
      time: stageTimes.value[2] || '待定'
    }]);
    const stageDone = stage => stages.value.some(s => s.stage === stage);
    const currentResult = computed(() => stages.value.find(s => s.stage === currentStage.value) || null);
    const selectStage = stage => {
      currentStage.value = stage;
      showReason.value = false;
    };
    const show = id => {
      matchId.value = id;
      isVisible.value = true;
      loading.value = true;
      stages.value = [];
      stageTimes.value = [];
      currentStage.value = 0;
      fetchPrediction();
    };
    const close = () => {
      isVisible.value = false;
    };
    const fetchPrediction = async () => {
      try {
        const response = await axios.get(`https://tuhaojie.asia/api-foot/aiPrediction/list?matchId=${matchId.value}`);
        const data = response.data?.data || response.data;
        const info = data.matchInfo || {};
        homeTeam.value = info.homeTeam || '';
        awayTeam.value = info.awayTeam || '';
        league.value = info.league || '';
        matchNumStr.value = info.matchNumStr || '';
        matchTime.value = info.matchTime || '';
        deadline.value = info.deadline || '';
        stageTimes.value = info.stageTimes || [];
        stages.value = (data.stages || []).map(s => ({
          ...s,
          scores: s.scores || [],
          reasoningPoints: s.reasoningPoints || []
        }));
        // 默认选中最新已生成阶段
        if (stages.value.length > 0) {
          currentStage.value = stages.value[stages.value.length - 1].stage;
        }
      } catch (e) {
        console.error('获取AI预测失败', e);
      } finally {
        loading.value = false;
      }
    };

    // ==================== 置信度/档位工具 ====================
    const isDimmed = c => threshold.value > 0 && (c === null || c === undefined || c < threshold.value);
    const confClass = c => {
      if (c >= 70) return 'high-confidence';
      if (c >= 40) return 'mid-confidence';
      return 'low-confidence';
    };
    const confColor = c => {
      if (c >= 70) return '#27ae60';
      if (c >= 40) return '#f39c12';
      return '#e74c3c';
    };
    const levelLabel = c => {
      if (c >= 70) return '高';
      if (c >= 40) return '中';
      return '低';
    };
    const levelType = c => {
      if (c >= 70) return 'success';
      if (c >= 40) return 'warning';
      return 'danger';
    };
    __expose({
      show,
      close
    });
    return (_ctx, _cache) => {
      const _component_var_radio = _resolveComponent("var-radio");
      const _component_var_radio_group = _resolveComponent("var-radio-group");
      const _component_var_progress = _resolveComponent("var-progress");
      const _component_var_chip = _resolveComponent("var-chip");
      const _component_var_loading = _resolveComponent("var-loading");
      const _component_nut_popup = _resolveComponent("nut-popup");
      return _openBlock(), _createBlock(_component_nut_popup, {
        visible: isVisible.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = $event => isVisible.value = $event),
        closeable: "",
        style: {
          padding: '50px 10px 20px',
          height: '88%',
          width: '92%',
          overflowY: 'auto',
          overflowX: 'hidden'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_var_loading, {
          description: "加载中",
          loading: loading.value
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(homeTeam.value) + " vs " + _toDisplayString(awayTeam.value), 1), _createElementVNode("div", _hoisted_2, [matchNumStr.value ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(matchNumStr.value) + " · ", 1)) : _createCommentVNode("", true), _createTextVNode(_toDisplayString(league.value) + " ", 1), matchTime.value ? (_openBlock(), _createElementBlock("span", _hoisted_4, " · 开赛 " + _toDisplayString(matchTime.value), 1)) : _createCommentVNode("", true), deadline.value ? (_openBlock(), _createElementBlock("span", _hoisted_5, " · 截单 " + _toDisplayString(deadline.value), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_var_radio_group, {
            modelValue: threshold.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => threshold.value = $event),
            direction: "horizontal"
          }, {
            default: _withCtx(() => [_createVNode(_component_var_radio, {
              "checked-value": 0
            }, {
              default: _withCtx(() => [_createTextVNode("全部")]),
              _: 1
            }), _createVNode(_component_var_radio, {
              "checked-value": 60
            }, {
              default: _withCtx(() => [_createTextVNode("≥60")]),
              _: 1
            }), _createVNode(_component_var_radio, {
              "checked-value": 70
            }, {
              default: _withCtx(() => [_createTextVNode("≥70")]),
              _: 1
            }), _createVNode(_component_var_radio, {
              "checked-value": 80
            }, {
              default: _withCtx(() => [_createTextVNode("≥80")]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]), _hoisted_8, _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stageMeta.value, meta => {
            return _openBlock(), _createElementBlock("div", {
              key: meta.stage,
              class: _normalizeClass(["stage-node", {
                active: currentStage.value === meta.stage
              }]),
              onClick: $event => selectStage(meta.stage)
            }, [_createElementVNode("div", {
              class: _normalizeClass(["stage-dot", {
                done: stageDone(meta.stage)
              }])
            }, [stageDone(meta.stage) ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createTextVNode("✓")], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [_createTextVNode(_toDisplayString(meta.stage), 1)], 64))], 2), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(meta.label), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(meta.time), 1)]), _createElementVNode("div", {
              class: _normalizeClass(["stage-status", {
                done: stageDone(meta.stage)
              }])
            }, _toDisplayString(stageDone(meta.stage) ? '已完成' : '待生成'), 3)], 10, _hoisted_10);
          }), 128))]), currentResult.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", {
            class: _normalizeClass(["conf-big", confClass(currentResult.value.totalConfidence)])
          }, _toDisplayString(currentResult.value.totalConfidence || '-') + "%", 3), _createVNode(_component_var_progress, {
            value: currentResult.value.totalConfidence,
            max: 100,
            color: confColor(currentResult.value.totalConfidence)
          }, null, 8, ["value", "color"]), _createVNode(_component_var_chip, {
            size: "small",
            type: levelType(currentResult.value.totalConfidence),
            style: {
              "margin-top": "6px"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(levelLabel(currentResult.value.totalConfidence)), 1)]),
            _: 1
          }, 8, ["type"])]), _createElementVNode("div", {
            class: _normalizeClass(["rec-card", {
              dimmed: isDimmed(currentResult.value.handicap.confidence)
            }])
          }, [_hoisted_16, _createElementVNode("div", _hoisted_17, _toDisplayString(currentResult.value.handicap.recommendation), 1), _createElementVNode("div", _hoisted_18, [_createElementVNode("span", {
            class: _normalizeClass(["rec-conf", confClass(currentResult.value.handicap.confidence)])
          }, _toDisplayString(currentResult.value.handicap.confidence) + "%", 3), _createVNode(_component_var_chip, {
            size: "small",
            type: levelType(currentResult.value.handicap.confidence)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(levelLabel(currentResult.value.handicap.confidence)), 1)]),
            _: 1
          }, 8, ["type"]), isDimmed(currentResult.value.handicap.confidence) ? (_openBlock(), _createBlock(_component_var_chip, {
            key: 0,
            size: "small",
            type: "warning",
            style: {
              "margin-left": "4px"
            }
          }, {
            default: _withCtx(() => [_createTextVNode("低置信")]),
            _: 1
          })) : _createCommentVNode("", true)]), currentResult.value.handicap.reason ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(currentResult.value.handicap.reason), 1)) : _createCommentVNode("", true)], 2), _createElementVNode("div", {
            class: _normalizeClass(["rec-card", {
              dimmed: isDimmed(currentResult.value.overUnder.confidence)
            }])
          }, [_hoisted_20, _createElementVNode("div", _hoisted_21, _toDisplayString(currentResult.value.overUnder.recommendation), 1), _createElementVNode("div", _hoisted_22, [_createElementVNode("span", {
            class: _normalizeClass(["rec-conf", confClass(currentResult.value.overUnder.confidence)])
          }, _toDisplayString(currentResult.value.overUnder.confidence) + "%", 3), _createVNode(_component_var_chip, {
            size: "small",
            type: levelType(currentResult.value.overUnder.confidence)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(levelLabel(currentResult.value.overUnder.confidence)), 1)]),
            _: 1
          }, 8, ["type"]), isDimmed(currentResult.value.overUnder.confidence) ? (_openBlock(), _createBlock(_component_var_chip, {
            key: 0,
            size: "small",
            type: "warning",
            style: {
              "margin-left": "4px"
            }
          }, {
            default: _withCtx(() => [_createTextVNode("低置信")]),
            _: 1
          })) : _createCommentVNode("", true)]), currentResult.value.overUnder.reason ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(currentResult.value.overUnder.reason), 1)) : _createCommentVNode("", true)], 2), _createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentResult.value.scores, (s, i) => {
            return _openBlock(), _createElementBlock("div", {
              key: i,
              class: _normalizeClass(["score-item", {
                dimmed: isDimmed(s.confidence)
              }])
            }, [_createElementVNode("div", _hoisted_27, _toDisplayString(s.score), 1), _createElementVNode("div", {
              class: _normalizeClass(["score-conf", confClass(s.confidence)])
            }, _toDisplayString(s.confidence) + "%", 3), s.reason ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(s.reason), 1)) : _createCommentVNode("", true)], 2);
          }), 128))])]), currentResult.value.summary ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_hoisted_30, _createElementVNode("div", _hoisted_31, _toDisplayString(currentResult.value.summary), 1)])) : _createCommentVNode("", true), currentResult.value.reasoningPoints && currentResult.value.reasoningPoints.length ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createElementVNode("div", {
            class: "reason-toggle",
            onClick: _cache[1] || (_cache[1] = $event => showReason.value = !showReason.value)
          }, [_hoisted_33, _createElementVNode("span", _hoisted_34, _toDisplayString(showReason.value ? '收起 ▲' : '展开 ▼'), 1)]), showReason.value ? (_openBlock(), _createElementBlock("div", _hoisted_35, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentResult.value.reasoningPoints, (p, i) => {
            return _openBlock(), _createElementBlock("div", {
              key: i,
              class: "reason-point"
            }, "· " + _toDisplayString(p), 1);
          }), 128))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), currentResult.value.risk ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_hoisted_37, _createElementVNode("div", _hoisted_38, _toDisplayString(currentResult.value.risk), 1)])) : _createCommentVNode("", true)], 64)) : currentStage.value && !currentResult.value ? (_openBlock(), _createElementBlock("div", _hoisted_39, "该阶段分析尚未生成，请稍后查看")) : (_openBlock(), _createElementBlock("div", _hoisted_40, "暂无分析结果，将在当天 12:00 / 赛前2小时 / 赛前30分钟 自动生成"))]),
          _: 1
        }, 8, ["loading"])]),
        _: 1
      }, 8, ["visible"]);
    };
  }
};